var mobileFileDelete = {};

/* Per-file staff "Delete File" for the COLLAPSED mobile thumbnail grid.

   The verb already exists on every staff file cell as the [D] link inside
   .uploadDetails (njk/cells/uploadCell.njk:10, js/posting.js:123), and the
   mobile grid display:none's .uploadDetails (_posting.scss, <=479px block:
   ".panelUploads .uploadCell .uploadDetails { display: none }") -> a mod
   staring at abuse on a phone had to EXPAND the thumbnail to act, which is
   exactly what they refuse to do when the thumbnail is the abuse. This control
   lives in the cell's first-child slot (the slot mediaHiding.js:100 uses) so
   it is reachable without expanding.

   Deliberately ONE verb. "Unlink" (the [U] link, no &delete) only detaches the
   file and leaves the bytes as an invisible orphan in media management
   (LynxChan miscDelOps.js removeFile -> checkNewOrphans), and is root-only by
   operator ruling 2026-10-22 -> it gets no mobile control at all.

   No click handler here on purpose: the anchor carries class
   `unlinkAndDeleteLink`, so posting.initUnlinkLinks (js/posting.js:1437)
   delegates it -- same json=1 fetch, same cell removal, same failure alert as
   the desktop link.

   Who gets it: the engine only renders the source [D] link for viewers it
   considers staff (LynxChan common.js setUploadModElements, `modding`), so
   "no source link" == "no control" here. CSS reveals it for body.staffView
   only, and LynxChan miscDelOps.singleFile re-checks the role server-side. */

mobileFileDelete.processCell = function(cell) {

  if (cell.getElementsByClassName('mobileDeleteFile').length) {
    return;
  }

  var source = cell.getElementsByClassName('unlinkAndDeleteLink')[0];

  var href = source && source.getAttribute('href');

  if (!href) {
    return;
  }

  var button = document.createElement('a');
  button.className = 'unlinkAndDeleteLink mobileDeleteFile';
  button.setAttribute('href', href);
  button.innerText = lang.deleteFile;

  cell.insertBefore(button, cell.firstChild);

};

mobileFileDelete.init = function() {

  var cells = document.getElementsByClassName('uploadCell');

  for (var i = 0; i < cells.length; i++) {
    mobileFileDelete.processCell(cells[i]);
  }

};

mobileFileDelete.init();
